var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-list',{staticStyle:{"height":"height","overflow":"auto"},attrs:{"finished":_vm.finished,"loading-text":'加载中...',"finished-text":'已显示全部',"error":_vm.error,"error-click":_vm.search},on:{"load":_vm.onLoad},model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }